import React from 'react';
import { MapPin, 
    // GraduationCap 
} from "lucide-react"
import { useTranslation } from "react-i18next"; // 1. Import i18next

const RegistrationHero: React.FC = () => {
    const { t } = useTranslation('registration'); // Gunakan namespace 'public'

    return (
        <section className="dark:from-gray-900 dark:to-gray-800 py-5 md:py-10 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-amber-50/30 to-blue-100/50 dark:from-blue-950/20 dark:via-amber-950/10 dark:to-blue-900/30"></div>
            <div className="container mx-auto px-4 relative z-10 text-center">
                {/* <div className="flex justify-center mb-4 md:mb-6">
                    <div className="bg-white/10 backdrop-blur-sm p-3 md:p-4 rounded-full border border-white/20">
                        <GraduationCap className="w-8 h-8 md:w-12 md:h-12 text-primary dark:text-blue-400" />
                    </div>
                </div> */}

                <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-bold mb-3 mt-20 md:mb-4 text-balance px-4">
                    {t('registration_hero.title_main')} <span className="text-accent">KONASPI XII</span>
                </h1>
                <p className="text-base sm:text-lg md:text-xl lg:text-2xl opacity-90 mb-6 md:mb-8 text-pretty px-4">
                    {t('registration_hero.tagline')}
                </p>

                <div className="flex flex-col gap-3 md:gap-6 justify-center items-center text-sm md:text-lg px-4">
                    <div className="flex items-center gap-2 md:gap-3 bg-white/50 dark:bg-white/10 backdrop-blur-sm px-4 md:px-6 py-2 md:py-3 rounded-full ">
                        <MapPin className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0 text-rose-500" />
                        <span className="text-center font-medium text-slate-800 dark:text-slate-200">
                            {t('registration_hero.venue')}
                        </span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default RegistrationHero;